import React from "react";
import { Tooltip } from "react-tooltip";
import { dashboard, tooltipContent } from "../../../../locales/en";
import {
  formatDateWithDayjs,
  formatFTNumber,
  formatToUSD
} from "../../../../utils/utils";
import {
  ZERO_NUMBER,
  STATUS_1,
  STATUS_5,
  STATUS_9,
  STATUS_12
} from "../../../../utils/constants/appConstants";
import { FaRegQuestionCircle } from "react-icons/fa";

export const COLUMNS = [
  {
    Header: "Funding Notice",
    Footer: "Funding Notice",
    accessor: "fundingNotice"
  },
  {
    Header: "FT number",
    Footer: "FT number",
    accessor: "fmfbFundQuotesId",
    Cell: ({ value }) => formatFTNumber(value)
  },
  {
    Header: "Status",
    Footer: "Status",
    accessor: "status"
  },
  {
    Header: "Date Funded",
    Footer: "Date Funded",
    accessor: "fundedAt",
    Cell: ({ value }) =>
      value ? formatDateWithDayjs(value, "DD-MMM-YYYY") : ""
  },
  {
    Header: "Due Date",
    Footer: "Due Date",
    accessor: "dueDate"
  },
  {
    Header: "Invoice Number",
    Footer: "Invoice Number",
    accessor: "invoiceNumber"
  },
  {
    Header: "Debtor",
    Footer: "Debtor",
    accessor: "debtor"
  },
  {
    Header: "Principal",
    Footer: "Principal",
    accessor: "fundingAmount",
    Cell: ({ value }) => formatToUSD(value)
  },
  {
    Header: "Fee",
    Footer: "Fee",
    accessor: "feeUntilDueDate",
    Cell: ({ value }) => formatToUSD(value)
  },
  {
    Header: "Payments",
    Footer: "Payments",
    accessor: "totalPaymentAmount",
    Cell: ({ value }) => formatToUSD(value)
  },
  {
    Header: "Payments Owing",
    Footer: "Payments Owing",
    accessor: "totalDueAmount",
    Cell: ({ value, row }) => {
      // The API sends internalQuoteStatusId as a number; the STATUS_* constants
      // are strings, so compare on a single string form.
      const statusId = String(row?.original?.internalQuoteStatusId);
      if (statusId === STATUS_5 || statusId === STATUS_12) return "";
      if (statusId === STATUS_1 || statusId === STATUS_9)
        return formatToUSD(ZERO_NUMBER);
      return formatToUSD(value);
    }
  },
  {
    Header: (
      <>
        <span id="repay-date-tooltip">
          {dashboard.invoiceDatatable.repayDate}
        </span>
        <span
          data-tooltip-id="fundedEdit"
          className="ms-2"
          data-tooltip-content={tooltipContent.content}
          onClick={(e) => e.stopPropagation()}
        >
          <FaRegQuestionCircle />
        </span>
        <Tooltip id="fundedEdit" className="report_tooltip custom_tooltip_bg" />
      </>
    ),
    Footer: "Repay Date",
    accessor: "repaymentDate"
  }
];
